<template>
	<div class="d-flex flex-column h-100">
		<div>
			<div class="row main-details-section">
				<div class="col-12 col-lg-8">
					<div class="row">
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.isActive') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-switch v-model="localData.isActive" :disabled="[FormModes.READONLY].includes(settings.mode) && grandParentType() === 'modal' ? true : null" :tabindex="101"></nk-switch>
							</nk-col-form-group>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.code') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.code" v-model="localData.code" :tabindex="102" @blur="codeBlur" ref="inputCode" @searchClick="allPersonnel" :disabled="[FormModes.READONLY].includes(settings.mode) && grandParentType() === 'modal' ? true : null" startup></nk-input>
							</nk-col-form-group>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.firstName') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.firstName" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="103"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.lastName') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.lastName" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="104"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.fatherName') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.fatherName" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="105"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.nationalCode') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.stringNumber" v-model="localData.nationalCode" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="106" :maxlength="10"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.idNumber') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.stringNumber" v-model="localData.idNumber" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="107"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.issuePlace') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.issuePlace" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="108"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.birthDate') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-date v-model="localData.birthDate" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="109"></nk-date>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.birthPlace') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.birthPlace" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="110"></nk-input>
							</nk-col-form-group>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.gender') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-dropdown v-model="localData.gender" :data="genderTypes" :options="componentOptions.selector('GenderTypes')" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="111"></nk-dropdown>
							</nk-col-form-group>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.nationality') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.nationality" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="112"></nk-input>
							</nk-col-form-group>
						</div>
						<div class="col-12 col-sm-6">
							<nk-col-form-group :label="$t('salary.personnel.f.religion') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
								<nk-input :options="componentOptions.string" v-model="localData.religion" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" :tabindex="113"></nk-input>
							</nk-col-form-group>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-4">
					<div class="image-container col-6">
						<nk-image-uploader ref="imageUploader" :options="componentOptions.imageUploader" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" />
					</div>
				</div>
			</div>
		</div>
		<nk-stabs class="mt-5 flex-grow-1" :activeTab="activeTab" :tabindex="100" :scrollable="true" @activeTabChanged="(tab: string) => tabChanged(tab)">
			<nk-stab :id="'contact-info'" :name="$t('salary.personnel.t.contact-info')" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null">
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.personnel.f.postalCode') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.stringNumber" v-model="localData.postalCode" :tabindex="115" :maxlength="10"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.personnel.f.phone') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.stringNumber" v-model="localData.phone" :tabindex="116"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.personnel.f.mobile1') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.stringNumber" v-model="localData.mobile1" :tabindex="117"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.personnel.f.mobile2') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.stringNumber" v-model="localData.mobile2" :tabindex="118"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.personnel.f.email') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.string" v-model="localData.email" :tabindex="119"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-lg-8" style="padding-right: 9px;">
						<nk-col-form-group :label="$t('salary.personnel.f.address') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 10 }">
							<nk-input :options="componentOptions.string" v-model="localData.address" :tabindex="120"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-lg-8" style="padding-right: 9px;">
						<nk-col-form-group :label="$t('salary.personnel.f.description') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 10 }">
							<nk-input :options="componentOptions.string" v-model="localData.description" :tabindex="121"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-lg-8" style="padding-right: 9px;">
						<nk-col-form-group :label="$t('salary.personnel.f.group') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 10 }">
							<nk-multichoice2 v-model="localData.personnelCategories" :data="personnelCategoriesList" ref="personnelCategory" :options="componentOptions.categories" :tabindex="122" class="w-100"></nk-multichoice2>
						</nk-col-form-group>
					</div>
				</div>
			</nk-stab>
			<nk-stab :id="'document-account'" :name="$t('salary.personnel.t.document-account')" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null">
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-8">
						<nk-col-form-group :label="$t('salary.personnel.f.bank') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown-bank v-model="localData.bank" :tabindex="123"></nk-dropdown-bank>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-8">
						<nk-col-form-group :label="$t('salary.personnel.f.bankAccountNumber') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.string" v-model="localData.bankAccountNumber" :tabindex="124"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-8">
						<nk-col-form-group :label="$t('salary.personnel.f.bankCardNumber') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.stringNumber" v-model="localData.bankCardNumber" :tabindex="125" :maxlength="16"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-8">
						<nk-col-form-group :label="$t('salary.personnel.f.bankShabaNumber') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.shabaNumber" v-model="localData.bankShabaNumber" :tabindex="126" :maxlength="24"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-sm-6 col-lg-8">
						<nk-col-form-group :label="$t('salary.personnel.f.floatingCenter') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown-center v-model="localData.floatingCenter" :options="componentOptions.personnel" :tabindex="127"></nk-dropdown-center>
						</nk-col-form-group>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-sm-6 col-lg-8">
						<nk-col-form-group :label="$t('salary.contract.f.documentFloatingCenterSelectionType') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.documentFloatingCenterSelectionType" :data="documentFloatingCenterSelectionTypes" :options="componentOptions.selector('DocumentFloatingCenterSelectionTypes')" :tabindex="128"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-8" v-if="localData.contract.documentFloatingCenterSelectionType">
						<nk-col-form-group :label="$t(`salary.personnel.f.${localData.contract.documentFloatingCenterSelectionType.toLowerCase()}FloatingCenter`) + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown-center v-if="localData.contract.documentFloatingCenterSelectionType === DocumentFloatingCenterSelectionTypes.WorkingPlace" v-model="localData.contract.workingPlaceFloatingCenter" :options="componentOptions.floatingCenter" :tabindex="129"></nk-dropdown-center>
							<nk-dropdown-center v-else-if="localData.contract.documentFloatingCenterSelectionType === DocumentFloatingCenterSelectionTypes.Workshop" v-model="localData.contract.workshopFloatingCenter" :options="componentOptions.floatingCenter" :tabindex="129"></nk-dropdown-center>
						</nk-col-form-group>
					</div>
				</div>
			</nk-stab>
			<nk-stab :id="'contract-info'" :name="$t('salary.personnel.t.contract-info')" v-if="!settings.hideContractTabs" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null">
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.marriage') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.marriage" :data="marriageTypes" :options="componentOptions.selector('MarriageTypes')" @update:modelValue="(val: PersonnelMarriageTypes) => marriageTypeChanged(val)" :tabindex="128"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.childrenCount') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.number" v-model="localData.contract.childrenCount" :disabled="localData.contract.marriage === PersonnelMarriageTypes.Single" :tabindex="129"></nk-input>
						</nk-col-form-group>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.militaryStatus') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.militaryStatus" :data="militaryTypes" :options="componentOptions.selector('MilitaryStatuses')" :tabindex="130"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.sacrificeStatus') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.sacrificeStatus" :data="sacrificeTypes" :options="componentOptions.selector('SacrificeStatuses')" :tabindex="131"></nk-dropdown>
						</nk-col-form-group>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.educationalStatus') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.educationalStatus" :data="educationTypes" :options="componentOptions.selector('EducationalStatuses')" :tabindex="132"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.educationalField') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.string" v-model="localData.contract.educationalField" :tabindex="133"></nk-input>
						</nk-col-form-group>
					</div>
				</div>
			</nk-stab>
			<nk-stab :id="'insurance-tax'" :name="$t('salary.personnel.t.insurance-tax')" v-if="!settings.hideContractTabs" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null">
				<div class="row nk-seprator">
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.insuranceBaseType') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.insuranceBaseType" :data="insuranceBaseTypes" :options="componentOptions.selector('InsuranceBaseTypes')" :tabindex="134"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.insuranceType') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.insuranceType" :data="insuranceTypes" :options="componentOptions.selector('InsuranceTypes')" :tabindex="135"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.insuranceNumber') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-input :options="componentOptions.string" v-model="localData.contract.insuranceNumber" :tabindex="136"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.personnel.f.jobCode') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.jobCode" :options="componentOptions.jobCode" :data="jobCodes" :tabindex="137" ref="jobCode"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.insuranceStartDate') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-date v-model="localData.contract.insuranceStartDate" :options="componentOptions.date" :tabindex="138"></nk-date>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.insuranceLeaveDate') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-date v-model="localData.contract.insuranceLeaveDate" :options="componentOptions.date" :tabindex="139"></nk-date>
						</nk-col-form-group>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-sm-6 col-lg-6">
						<div class="row flex-row-reverse">
							<div class="col-10 px-2">
								<nk-checkbox type="checkbox" :options="{ title: $t('salary.contract.f.exportableInInsuranceDisket') }" v-model="localData.contract.exportableInInsuranceDisket" :tabindex="140" />
							</div>
						</div>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-sm-6 col-lg-6">
						<div class="row flex-row-reverse">
							<div class="col-10 px-2">
								<nk-checkbox type="checkbox" :options="{ title: $t('salary.contract.f.includeHardJob') }" v-model="localData.contract.insuranceIncludeHardJob" :tabindex="141" />
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.workplaceStatus') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.workplaceStatus" @update:modelValue="(item: WorkPlaceStatus | null) => setTaxFreePercent(item?.taxFreePercent || 0)" :data="workplaceStatus" :options="componentOptions.workplaceStatus" :tabindex="142" ref="workplaceStatus"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.taxFreeAmount') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<div class="d-flex">
								<nk-input :options="componentOptions.number" v-model="localData.contract.taxFreeAmount" :tabindex="143"></nk-input>
								<nk-input :options="componentOptions.taxFreePercentage" v-model="localData.contract.taxFreePercentage" :tabindex="144"></nk-input>
							</div>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.jobField') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.jobField" :data="jobFields" :options="componentOptions.jobField" ref="jobField" :tabindex="147"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.taxStartDate') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-date v-model="localData.contract.taxStartDate" :options="componentOptions.date" :tabindex="149"></nk-date>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.taxEndDate') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-date v-model="localData.contract.taxEndDate" :options="componentOptions.date" :tabindex="151"></nk-date>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">

						<nk-col-form-group :label="$t('salary.contract.f.cooperateType') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }" ref="cooperateType">
							<nk-dropdown v-model="localData.contract.cooperateType" :data="cooperateTypes" :options="componentOptions.cooperateType" :tabindex="153"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6 col-lg-4">
						<nk-col-form-group :label="$t('salary.contract.f.position') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
							<nk-dropdown v-model="localData.contract.position" :data="positions" :options="componentOptions.position" ref="position" :tabindex="155"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-sm-9 col-lg-6">
						<div class="row flex-row-reverse">
							<div class="col-10 px-2">
								<nk-checkbox type="checkbox" :options="{ title: $t('salary.contract.f.exportableInTaxDisket') }" v-model="localData.contract.exportableInTaxDisket" :tabindex="157" />
							</div>
						</div>
					</div>
				</div>
			</nk-stab>
			<nk-stab :id="'additional-fields'" :name="$t('salary.personnel.t.additional-fields')" :disabled="[FormModes.READONLY].includes(settings.mode) ? true : null" v-if="!settings.hideContractTabs">
				<div v-if="$refs.metaDataList && ($refs.metaDataList as any).metaDatas.length === 0 && [FormModes.EDITABLE].includes(settings.mode)" class="row w-100 h-100 justify-content-center align-items-center flex-column gap-10">
					<div class="bold-title">{{ $t('salary.personnel.m.no-additional-field-found') }}</div>
					<nk-button class="mb-4" @click="metaDataModal" :options="componentOptions.addMetaDataButton" />
				</div>
				<nk-metadata ref="metaDataList" :tabindex="157" :options="getMetaDataListOptions" />
			</nk-stab>
		</nk-stabs>
	</div>
</template>

<script lang="ts">
	import { PersonnelGenderTypes, PersonnelMarriageTypes, PersonnelSacrificeStatusTypes, PersonnelEmploymentTypes, PersonnelMilitaryStatusTypes, PersonnelEducationalStatusTypes, InsuranceTypes, InsuranceBaseTypes, DocumentFloatingCenterSelectionTypes } from '@/enums/salary'
	import { Personnel } from '@/classes/salary/personnel'
	import { PropType, defineAsyncComponent, defineComponent } from 'vue'
	import { Guid, IResponseList } from '@/interfaces/base'
	import CloneDeep from 'lodash/cloneDeep'
	import Extend from 'lodash/extend'
	import IsEqual from 'lodash/isEqual'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import validators, { isEmpty, Checker, VEmail, VIranNationalCode, VIranPostalCode, VRegex, VCustom, VRequiredIfValue } from '@/statics/validators'
	import { PersonnelCategory } from '@/classes/salary/personnel-category'
	import { post } from '@/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { IResponse, TNikanDate } from '~/interfaces/base'
	import { AxiosError } from 'axios'
	import { TYPE } from 'vue-toastification'
	import emptyId from '~/statics/empty-id'
	import TabOrder from '~/statics/taborder-functions'
	import { mapActions, mapGetters } from 'vuex'
	import PersonnelCategoryModify from '~/views/salary/personnel/personnel-category/personnel-category-modify.vue'
	import { Contract } from '@/classes/salary/contract'
	import { ISanpshotInitializer } from '~/interfaces/plugins/snapshot'
	import CooperateTypeSelector from '@/components/form/salary/common/cooperate-type-selector.vue'
	import { CooperateType } from '@/classes/salary/cooperate-type'
	import { JobCode } from '~/classes/salary/job-code'
	import JobCodeSelector from '~/components/form/salary/common/job-code-selector.vue'
	import { WorkPlaceStatus } from '~/classes/salary/workplace-status'
	import WorkPlaceStatusSelector from '~/components/form/salary/common/workplace-status-selector.vue'
	import { personnelSchemaGenerator } from '~/plugins/stimul-utils'
	import PersonnelSelector from './personnel-selector.vue'
	import MetaDataSchemaModify from '../../meta-data/meta-data-schema-modify.vue'
	import { FormModes } from '@/enums/system'
	import { JobField } from '~/classes/salary/job-field'
	import JobFieldSelector from '../common/job-field-selector.vue'
	import { Position } from '@/classes/salary/position'
	import PositionSelector from '../common/position-selector.vue'

	interface PersonnelDto {
		personnel: Personnel
		contract: Contract
	}

	export default defineComponent({
		props: {
			data: {
				type: Object as PropType<Personnel>
			},
			options: {
				type: Object
			}
		},
		emits: ['personnelLoad', 'clearForm', 'updateContract'],
		components: {
			PersonnelCategoryModify,
		},
		data() {
			return {
				PersonnelMarriageTypes,
				DocumentFloatingCenterSelectionTypes,
				FormModes: FormModes,
				isPrepared: true,
				onCodeEnterPressed: false,
				banks: [],
				personnelCategoriesList: [] as PersonnelCategory[],
				jobCodes: [] as JobCode[],
				workplaceStatus: [] as WorkPlaceStatus[],
				cooperateTypes: [] as CooperateType[],
				insuranceTypes: Object.values(InsuranceTypes),
				insuranceBaseTypes: Object.values(InsuranceBaseTypes),
				marriageTypes: Object.values(PersonnelMarriageTypes),
				sacrificeTypes: Object.values(PersonnelSacrificeStatusTypes),
				militaryTypes: Object.values(PersonnelMilitaryStatusTypes),
				educationTypes: Object.values(PersonnelEducationalStatusTypes),
				documentFloatingCenterSelectionTypes: Object.values(DocumentFloatingCenterSelectionTypes),
				genderTypes: Object.values(PersonnelGenderTypes),
				localData: new Personnel(),
				jobFields: [] as JobField[],
				positions: [] as Position[],
				originalData: {} as Personnel,
				activeTab: 'contact-info',
				footerButtons: [
					{
						type: 'snapshot',
						options: () => {
							return {
								fillData: this.fillPersonnel,
								snapshotInstance: this.snapshotInstance
							}
						}
					},
					{
						icon: 'list-ul',
						handle: () => {
							this.metaDataModal()
						},
						isPrimary: true,
						policyClaims: 'General_MetaDataSchema_Management'
					},
					{
						id: 'personnel-log',
						title: this.$t('change-log.f.change-log'),
						handle: () => {
							this.getChangeLog()
						},
						icon: 'scroll',
						policyClaims: 'General_ChangeLog_List',
					}
				],
				settings: {
					id: '',
					mode: FormModes.EDITABLE,
					hideContractTabs: false
				},
				componentOptions: {
					date: {
						pickerEnabled: true,
						pickerCss: 'btn btn-default',
						emptyValue: null
					},
					shabaNumber: {
						icon2: '-IR',
						mode: 'strnumber',
					},
					workplaceStatus: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: (item: JobCode) => item.name,
						buttons: [
							{
								title: this.$t('list'),
								shortcut: $sc.find('enter'),
								isPrimary: true,
								element: () => this.$refs.workplaceStatus.$el,
								icon: 'list-ul',
								handle: () => {
									this.showWorkPlaceSelector()
								}
							}
						]
					},
					jobCode: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name', 'code'],
						display: (item: JobCode) => item.name,
						buttons: [
							{
								title: this.$t('list'),
								shortcut: $sc.find('enter'),
								isPrimary: true,
								element: () => this.$refs.jobCode.$el,
								icon: 'list-ul',
								handle: () => {
									this.showJobCodeSelector()
								}
							}
						]
					},
					position: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: (item: Position) => item.title,
						buttons: [
							{
								title: this.$t('list'),
								shortcut: $sc.find('enter'),
								isPrimary: true,
								element: () => this.$refs.position.$el,
								icon: 'list-ul',
								handle: () => {
									this.showPositionSelector()
								}
							}
						]
					},
					imageUploader: {
						image: {
							height: 150,
							width: 150,
							defaultImage: 'personnel',
						}
					},
					categories: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item: PersonnelCategory) {
							return item.name
						},
						dropdown: {
							buttons: [{
								title: this.$t('list'),
								shortcut: $sc.find('enter'),
								isPrimary: true,
								element: () => { return this.$refs.personnelCategory },
								icon: 'list-ul',
								handle: () => {
									this.personnelCategoryModify()
								}
							}]
						},
						searchableFields: ['name'],
					},
					code: {
						searchable: true,
						mode: 'string',
					},
					string: {
						mode: 'string'
					},
					stringNumber: {
						mode: 'strnumber'
					},
					number: {
						mode: 'number'
					},
					money: {
						mode: 'price',
					},
					taxFreePercentage: {
						mode: 'percent',
						icon: 'percent',
						// inputClasses: { 'text-right': true },
						ltr: true,
						placeholder: 'درصد'
					},
					selector: (fieldType: string) => {
						return {
							searchable: true,
							required: true,
							remoteSearch: false,
							placeholder: this.$t('select-it'),
							display: (item: string, index: number): string => {
								return `${this.$t(`enum-items.${fieldType}.${item}`)} ${(index || index === 0) && ['InsuranceBaseTypes', 'EducationalStatuses'].includes(fieldType) ? `(${index + 1})` : ''}`
							},
							// searchableFields: ['key'],
							searchPrefix: `enum-items.${fieldType}`,
						}
					},
					cooperateType: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						// searchableFields: ['key'],
						searchPrefix: `salary.personnel.tax-cooperate-type`,
						buttons: [
							{
								title: this.$t('list'),
								shortcut: $sc.find('enter'),
								isPrimary: true,
								element: () => this.$refs.cooperateType.$el,
								icon: 'list-ul',
								handle: this.showCooperateType
							}
						]
					},
					banksDropdown: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item: { title: string, id: Guid }): string {
							return item.title
						},
						searchableFields: ['title'],
					},
					personnel: {
						rowIdentifier: 'id',
						searchable: true,
						required: true,
						baseAccountId: null,
						centerLevel: 0,
						remoteSearch: false,
						placeholder: this.$t('autoAccount.choose-center'),
						display: (item: any) => `${item.accountingCode} - ${item.name}`,
						searchableFields: ['name', 'accountingCode'],
						loadAllIfBaseAccountIsEmpty: true,
						selectorWidth: 350,
						showIfRelatedAccountIsEmpty: true,
						linkNewCenterToAccount: false,
						group: ['Personel'],
					},
					floatingCenter: {
						rowIdentifier: 'id',
						searchable: true,
						required: true,
						baseAccountId: null,
						centerLevel: 0,
						remoteSearch: false,
						placeholder: this.$t('autoAccount.choose-center'),
						display: (item: any) => `${item.accountingCode} - ${item.name}`,
						searchableFields: ['name', 'accountingCode'],
						loadAllIfBaseAccountIsEmpty: true,
						selectorWidth: 350,
						showIfRelatedAccountIsEmpty: true,
						linkNewCenterToAccount: false,
					},
					addMetaDataButton: {
						title: this.$t('salary.personnel.f.define-additional-fields'),
						icon: 'plus',
						isPrimary: true
					},
					jobField: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: (item: JobField) => item.name,
						// buttons: [
						// 	{
						// 		title: this.$t('list'),
						// 		shortcut: $sc.find('enter'),
						// 		isPrimary: true,
						// 		element: () => this.$refs.jobField.$el,
						// 		icon: 'list-ul',
						// 		handle: () => {
						// 			this.showJobFieldSelector()
						// 		}
						// 	}
						// ]
					},
				},
				validators: {
					code: validators('required'),
					firstName: validators('required'),
					lastName: validators('required'),
					fatherName: validators('required'),
					nationalCode: validators('required', new VIranNationalCode()),
					idNumber: validators('required'),
					issuePlace: validators('required'),
					gender: validators('required'),
					birthDate: validators('required'),
					birthPlace: validators('required'),
					email: validators(new VEmail()),
					postalCode: validators(new VIranPostalCode()),
					bankCardNumber: validators(new VRegex(/(?=.{16}$)[0-9]*$/)),
					bankShabaNumber: validators(new VRegex(/(?=.{24}$)[0-9]*$/)),
				},
				contractValidators: {
					insuranceType: validators('required'),
					// insuranceStartDate: validators(new VCustom(
					// 	this.validatorRequiredIfInsuranceTypeIsSet,
					// 	() => {
					// 		return this.$t('salary.contract.m.insuranceStartDate-required')
					// 	}
					// )),
					insuranceNumber: validators(new VCustom(
						this.validatorRequiredIfInsuranceTypeIsSet,
						() => {
							return this.$t('salary.contract.m.insuranceNumber-required')
						}
					)),
					taxFreePercentage: validators(new VCustom(
						(val: any, data: any) => {
							return !(data.taxFreePercentage && data.taxFreeAmount)
						},
						() => this.$t('salary.contract.m.both-taxFreeAmount-and-taxFreePercent-cano-not-fill')
					)),
					documentFloatingCenterSelectionType: validators('required'),
					workingPlaceFloatingCenter: validators(new VRequiredIfValue('documentFloatingCenterSelectionType', (val: DocumentFloatingCenterSelectionTypes) => val === DocumentFloatingCenterSelectionTypes.WorkingPlace)),
					workshopFloatingCenter: validators(new VRequiredIfValue('documentFloatingCenterSelectionType', (val: DocumentFloatingCenterSelectionTypes) => val === DocumentFloatingCenterSelectionTypes.Workshop)),
				}
			}
		},
		computed: {
			...mapGetters({
				getSalaryPeriod: 'appContext/getSalaryPeriod',
				getWorkshop: 'appContext/getWorkshop',
			}),
			getMetaDataListOptions() {
				return {
					subject: 'Personnel',
					data: this.localData.metaDatas || [],
					prefix: 'Personnel',
					columnSize: 4,
					dataSizes: { sm: 8 },
					labelSizes: { sm: 4 },
					labelAligns: { lg: 'left', md: 'left', sm: 'left' },
				}
			},
		},
		created() {
			this.setComponentSettings()
			this.originalData = CloneDeep(this.localData)
		},
		mounted() {
			if (this.settings.id) {
				this.getPersonnelById(this.settings.id)
			}

			if (this.data)
				this.fillPersonnel(this.data)

			this.loadJobFields()
			this.loadPositions()
			this.getEssentialData()
			this.focusOnCode()
		},
		methods: {
			...mapActions({
				broadcastItemExist: 'socket/broadcastItemExist',
			}),
			print_dataSources() {
				return [personnelSchemaGenerator([this.localData])]
			},
			loadJobFields(): void {
				const wait = this.$wait(this.$el)
				post(Endpoints.getUrl('jobField.listDynamic'))
					.then((res: IResponseList<JobField>) => {
						this.jobFields = res.data.items
					})
					.finally(() => {
						wait.end()
					})
			},
			showJobFieldSelector(): void {
				this.showModal({
					component: JobFieldSelector,
				})
					.then((res: JobField) => {
						this.localData.contract.jobField = res
						this.loadJobFields()
					})
					.catch(() => { })
			},
			showPositionSelector() {
				this.showModal({
					component: PositionSelector,
				})
					.then((res: Position) => {
						this.localData.contract.position = res
						this.loadPositions()
					})
					.catch(() => { })
			},
			loadPositions() {
				const wait = this.$wait(this.$el)
				post(Endpoints.getUrl('position.listDynamic'))
					.then((res: IResponseList<Position>) => {
						this.positions = res.data.items
					})
					.finally(() => {
						wait.end()
					})
			},
			validatorRequiredIfInsuranceTypeIsSet(item: TNikanDate | number) {

				if (this.localData.contract?.insuranceType && this.localData.contract?.insuranceType !== InsuranceTypes.NotInsurance)
					return !!item

				return true
			},
			showWorkPlaceSelector(): void {
				this.showModal({
					component: WorkPlaceStatusSelector,
				})
					.then((res: WorkPlaceStatus) => {
						this.localData.contract.workplaceStatus = res
						this.setTaxFreePercent(res.taxFreePercent)
						const wait = this.$wait(this.$el)
						this.loadWorkPlaceStatuses().finally(() => wait.end())
					})
					.catch(() => { })
			},
			loadWorkPlaceStatuses(): Promise<void> {
				return post(Endpoints.getUrl('workplaceStatus.listDynamic'))
					.then((res: IResponseList<WorkPlaceStatus>) => {
						this.workplaceStatus = res.data.items
					})
			},
			loadJobCodes(): Promise<void> {
				return post(Endpoints.getUrl('jobCode.listDynamic'))
					.then((res: IResponseList<JobCode>) => {
						this.jobCodes = res.data.items
					})
			},
			showJobCodeSelector(): void {
				this.showModal({
					component: JobCodeSelector,
				})
					.then((res: JobCode) => {
						this.localData.contract.jobCode = res
						const wait = this.$wait(this.$el)
						this.loadJobCodes().finally(() => wait.end())
					})
					.catch(() => { })
			},
			getEssentialData() {
				let wait = this.$wait(this.grandParent)
				Promise.all([this.getPersonnelCategories(), this.getCooperateTypes(), this.loadWorkPlaceStatuses(), this.loadJobCodes()]).finally(() => wait.end())
			},
			showCooperateType(): void {
				this.showModal({
					component: CooperateTypeSelector,
				})
					.then((res: CooperateType) => {
						this.localData.contract.cooperateType = res
						this.getCooperateTypes()
					})
					.catch(() => { })
			},
			getCooperateTypes(): Promise<void> {
				return post(Endpoints.getUrl('cooperateType.listDynamic'))
					.then((res: IResponseList<CooperateType>) => {
						this.cooperateTypes = res.data.items
					})
			},
			snapshot(): ISanpshotInitializer {
				return {
					form: 'personnel-info',
					isDataChanged: this.isDataChanged,
					retrieveData: () => {
						var snap = CloneDeep(this.localData)
						return snap
					}
				}
			},
			getPersonnelById(id: string): void {
				let data = { personnelId: id, code: null }
				this.getPersonnel(data).then((response) =>
					this.fillPersonnel(response)
				)
			},
			codeBlur(): void {
				if (this.originalData && !this.onCodeEnterPressed && !this.$refs.inputCode) {
					this.loadIfPossible(this.localData.code, false)
				}
				this.onCodeEnterPressed = false
			},
			loadIfPossible(code: string, useToast: boolean = true, navigateOptions = null): void {
				let methods = {
					retreiveIsEmpty: this.retrieveIsEmpty,
					fillData: this.fillPersonnel,
					getData: this.getPersonnelByCode,
					clearForm: this.clearForm,
					changedFormAlert: this.changedFormAlert,
					isDataChanged: this.isDataChanged,
					navigate: this.navigateToPersonnel,
					save: this.save,
				}
				let data = {
					originalData: this.originalData,
					searchCode: code,
				}
				this.$nikan.formUtility.loadIfPossible(methods, data, { keyword: this.$t('forms.Personnel'), useToast: useToast }, navigateOptions)
			},
			getPersonnelByCode(request: { searchCode: string }): Promise<Personnel> {
				let data = {
					code: request.searchCode,
					personnelId: null
				}
				return this.getPersonnel(data)
			},
			getPersonnel(request: { code: string | null, personnelId: Guid | null }): Promise<Personnel> {
				const req = Extend({}, request, { salaryPeriodId: this.getSalaryPeriod.id, workshopId: this.getWorkshop.id })
				return new Promise<Personnel>((resolve, reject) => {
					var wait = this.$wait(this.$refs.inputCode.$el, { size: 'small' })
					post(Endpoints.getUrl('personnel.get'), req, null, { silent: true, preventConcurrent: true, ignoreCommercialAccess: false, checkWarning: true }) // TODO:
						.then((result: IResponse<Personnel>) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err: any) => {
							if (err.errorCode === 'NotFound') {
								this.clearForm(true)
							}
							wait.end()
							reject(err)
						})
				})
			},
			fillPersonnel(personnel: Personnel): void {
				this.localData = personnel
				if (!personnel.contract) {
					this.localData.contract = new Contract()
				}
				if (String(this.localData.contract.employmentType) === '0')
					this.localData.contract.employmentType = PersonnelEmploymentTypes.Contractual

				this.originalData = CloneDeep(this.localData)
				this.$emit('personnelLoad', this.originalData)
			},
			allPersonnel(): void {
				this.showModal({ component: PersonnelSelector })
					.then((result: Personnel) => {
						this.loadIfPossible(result.code)
					})
					.catch(() => { })
					.finally(() => this.defer(() => this.$refs.inputCode.$el.focus(), 1))
			},
			clearForm(withEmit: boolean = false): void {
				this.activeTab = 'contact-info'
				if (withEmit) {
					this.localData = new Personnel()
					this.originalData = CloneDeep(this.localData)
					this.$emit('clearForm', this.localData)
				} else {
					this.localData = new Personnel()
					this.originalData = CloneDeep(this.localData)
				}
				this.$refs.metaDataList.refresh()
			},
			async isDataChanged(): Promise<boolean> {
				const localData = CloneDeep(this.localData)
				localData.code = this.originalData.code
				return !IsEqual(localData, this.originalData)
			},
			changedFormAlert(act: any, params?: any): Promise<void> {
				return new Promise<void>((resolve, reject) => {
					dialog({
						title: this.$t('salary.personnel.m.unsaved-personnel'),
						body: this.$t('salary.personnel.m.unsaved-personnel-description', {
							code: this.originalData.code,
						}),
						buttons: [
							{
								title: this.$t('document.dialog.saveAsSaved'),
								shortcut: $sc.find('yes', 'dialog'),
								isPrimary: true,
								handle: () => {
									this.localData.code = this.originalData.code
									this.save(false)!
										.then(() => {
											this.$refs.inputCode.$el.focus()
											act(params)
										})
										.then(() => resolve())
										.catch((error) => reject(error))
								},
							},
							{
								title: this.$t('document.dialog.ignoreChanges-load'),
								shortcut: $sc.find('ignore-changes', 'document'),
								isPrimary: true,
								handle: () => {
									this.localData = CloneDeep(this.originalData)
									act(params)
									resolve()
								},
							},
							{
								title: this.$t('dialog.return'),
								shortcut: $sc.find('return', 'dialog'),
								isCancel: true,
								handle: () => {
									reject()
								},
							},
						],
					})
				})
			},
			save(withClearForm: boolean = true): Promise<void> | void {
				return new Promise<void>((resolve, reject) => {
					this.localData.metaDatas = this.$refs.metaDataList.commitData()

					const emptyFields: (keyof Personnel)[] = ['postalCode', 'mobile1', 'mobile2']

					emptyFields.forEach((field) => {
						if (this.localData[field] === '')
							// @ts-ignore
							this.localData[field] = null
					})

					const data: PersonnelDto = {
						personnel: this.localData,
						contract: this.localData.contract
					}
					data.contract.salaryPeriod = this.getSalaryPeriod
					data.contract.workshop = this.getWorkshop
					if (!this.validateInputs(data.personnel, data.contract))
						return

					const isNew = this.retrieveIsEmpty()

					if (!data.contract.taxStartDate)
						delete data.contract.taxStartDate

					const wait = this.$wait(this.grandParent)
					post(Endpoints.getUrl(isNew ? 'personnel.create' : 'personnel.update'), data).then((res: IResponse<any>) => {
						this.$toast(this.$t('salary.personnel.m.save-success', { code: res.data.code }), { type: TYPE.SUCCESS })
						this.broadcastItemExist({ form: this.$t('forms.Personnel'), code: res.data.code })
						if (withClearForm)
							this.clearForm(true)
						else {
							this.originalData = CloneDeep(this.localData)

							if (!isNew)
								this.$emit('updateContract')
						}
						resolve()
					}).catch(() => {
						reject()
					}).finally(() => {
						wait.end()
					})
				})
			},
			validateInputs(personnel: Personnel, contract: Contract): boolean {
				let checker = new Checker((type: string) => this.$t(`salary.personnel.f.${type}`))
				let errors = checker.test(personnel, this.validators)

				let contractChecker = new Checker((type: string) => this.$t(`salary.contract.f.${type}`))
				errors = errors.concat(contractChecker.test(contract, this.contractValidators))

				if (contract.taxStartDate && contract.taxEndDate && !isEmpty(contract.taxEndDate) && new Date(contract.taxStartDate) > new Date(contract.taxEndDate))
					errors.push({ key: 'contract', error: this.$t('salary.contract.m.taxEndDate-should-be-larger') })

				this.validationToast(errors)
				return errors.length === 0
			},
			retrieveIsEmpty(): boolean {
				return !(this.localData && this.localData?.id !== emptyId)
			},
			navigateToPersonnel(direction: 'previous' | 'next', id?: Guid): Promise<Personnel> {
				let wait = this.$wait(this.$el)
				let data = {
					id: id && id !== emptyId ? id : null,
					navigationDirection: direction,
				}
				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('personnel.navigate'), data, null, { silent: true })
						.then((result: IResponse<Personnel>) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err: AxiosError<any>) => {
							wait.end()
							reject(err)
						})
				})
			},

			personnelCategoryModify() {
				this.showModal({
					component: PersonnelCategoryModify,
				})
					.then((res) => {
						if (this.$refs.personnelCategory)
							this.$refs.personnelCategory.refocusDropdown()
						let wait = this.$wait(this.grandParent)
						this.getPersonnelCategories().finally(() => wait.end())
					})
					.catch(err => {
						if (this.$refs.personnelCategory)
							this.$refs.personnelCategory.refocusDropdown()
					})
			},
			getPersonnelCategories() {
				return post(Endpoints.getUrl('personnelCategory.list'), {}).then((res: IResponseList<PersonnelCategory>) => {
					this.personnelCategoriesList = res.data.items
				}).catch(() => {
				})
			},
			focusOnCode() {
				this.$refs.inputCode.$el.focus()
			},
			loadPersonnel(code: string) {
				this.loadIfPossible(code)
			},
			prepareComponent() {
				if (this.isPrepared)
					return

				this.localData.contract = this.data!.contract
				this.originalData = CloneDeep(this.localData)

				this.isPrepared = true
			},
			setComponentSettings() {
				this.settings = Extend({}, this.settings, this.options)
			},
			tabChanged(tab: string) {
				this.activeTab = tab
			},
			metaDataModal() {
				this.showModal({
					component: MetaDataSchemaModify,
					options: {
						subject: 'Personnel',
						title: this.$t('salary.personnel.additional-fields.title'),
						prefix: 'Personnel',
						addSystemFieldConnector: false,
						windowTitlePrefix: '',
					},
				}).then((res) => {
					this.$refs.metaDataList.refresh()
				}).catch(() => {

				})
			},
			setTaxFreePercent(percent: number) {
				this.localData.contract.taxFreePercentage = percent
			},
			marriageTypeChanged(val: PersonnelMarriageTypes) {
				if (val === PersonnelMarriageTypes.Single)
					this.localData.contract.childrenCount = 0
			},
			getChangeLog() {
				let entityTitle
				if (this.localData.id) {
					entityTitle = this.$t('change-log.f.personnel-log-title', {
						code: this.localData.firstName + ' ' + this.localData.lastName,
					})
				} else {
					entityTitle = this.$t('change-log.f.personnels-log-title')
				}
				this.showModal({
					component: defineAsyncComponent(() => import('~/components/form/change-log/change-log.vue')),
					options: {
						entityId: this.localData.id,
						entityType: 'Personnel',
						entityTitle: entityTitle,
					},
				})
					.then(() => this.defer(() => this.$refs.inputCode.$el.focus(), 1))
					.catch(() => this.defer(() => this.$refs.inputCode.$el.focus(), 1))
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'load-personnel',
					keyCode: 13,
					el: this.$refs.inputCode.$el,
					context: this,
					handler: function (sender: any, e: any) {
						e.preventDefault()
						//@ts-ignore
						this.onCodeEnterPressed = true
						//@ts-ignore
						this.loadIfPossible(this.localData.code)
					},
				})
			}
		}
	})
</script>

<style lang="less">
	.bold-title {
		font-weight: bold;
		font-size: 20px;
	}

	.main-details-section {
		@media screen and (max-width: 1272px) {
			flex-direction: column-reverse !important;
		}

		flex-direction: row !important;
	}
</style>